import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY, PORCELAIN } from '@constant/colors';

const Back = ({ className, onClick, onKeyDown, label, buttonType }) => (
  <button
    onClick={onClick}
    onKeyDown={onKeyDown}
    className={className}
    aria-label={label}
    type={buttonType}
  >
    <svg viewBox="0 0 32 32" focusable="false">
      <g fill="none" fillRule="evenodd">
        <rect width="100%" height="100%" fill={PORCELAIN} rx="50%" />
        <path
          fill={OSLO_GRAY}
          d="M18.885 10.814l-1.57-1.57-7.072 7.07 7.07 7.07 1.572-1.57-5.5-5.5 5.5-5.5z"
        />
      </g>
    </svg>
  </button>
);

Back.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  label: PropTypes.string,
  buttonType: PropTypes.string,
};

export default Back;
